import { defineMessages } from 'react-intl';

export default defineMessages({
  menuItemHome: {
    id: 'features.home.menuItemHome',
    defaultMessage: 'Home',
    description: '',
  },
  menuItemWallet: {
    id: 'features.home.menuItemWallet',
    defaultMessage: 'Portafoglio',
    description: '',
  },
  menuItemSign: {
    id: 'features.home.menuItemSign',
    defaultMessage: 'Area firma',
    description: '',
  },
  menuItemDocuments: {
    id: 'features.home.menuItemDocuments',
    defaultMessage: 'Documenti',
    description: '',
  },
  menuItemForYou: {
    id: 'features.home.menuItemForYou',
    defaultMessage: 'Azimut per te',
    description: '',
  },
  menuItemNews: {
    id: 'features.home.menuItemNews',
    defaultMessage: 'News',
    description: '',
  },
  menuItemFaq: {
    id: 'features.home.menuItemFaq',
    defaultMessage: 'Faq',
    description: '',
  },
  menuItemPersonalArea: {
    id: 'features.home.menuItemPersonalArea',
    defaultMessage: 'Area personale',
    description: '',
  },
  menuItemOthers: {
    id: 'features.home.menuItemOthers',
    defaultMessage: 'Altro',
    description: '',
  },
  menuItemLogout: {
    id: 'features.home.menuItemLogout',
    defaultMessage: 'Logout',
    description: '',
  },
  breadcrumbEr: {
    id: 'features.home.breadcrumbEr',
    defaultMessage: 'Economia reale',
    description: '',
  },
  breadcrumbDetail: {
    id: 'features.home.breadcrumbDetail',
    defaultMessage: 'Dettaglio',
    description: '',
  },
});
